/**
 * Maps OncoEMR inbox API rows to notification center drawer items.
 * @module mapTaskToNotificationItem
 */

import type { OncoemrTaskListItem } from "../../data-model/oncoemrTasksModel";
import { formatDate } from "../../utils/formatDate";
import {
  ONCOEMR_MESSAGE_SENDER_UNKNOWN,
  resolveMessageSenderDisplayName,
} from "../../utils/oncoemrTaskHelpers";
import type { TasksNotificationCenterItem } from "./tasksNotificationTypes";

const LAST_ACTIVITY_FORMAT = "M/D/YY, h:mm A";

/**
 * Converts an unread inbox task row into a notification center list item.
 *
 * @param task - Task row from `GET /oncoemr-tasks`.
 * @returns Drawer row; `orderId` may be empty when the API omits it.
 */
export const mapTaskToNotificationItem = (
  task: OncoemrTaskListItem,
): TasksNotificationCenterItem => ({
  id: task.id,
  taskRowId: task.id,
  orderId: task.order_id ?? "",
  title: task.title,
  timestampLabel: formatDate(task.last_activity_at, LAST_ACTIVITY_FORMAT),
  mrn: task.patient_id,
  senderName: task.last_message
    ? resolveMessageSenderDisplayName(task.last_message)
    : ONCOEMR_MESSAGE_SENDER_UNKNOWN,
});
